<script>
export default {
  locales: {
    pt: {
      'My Investment': 'Meu Investimento',
      'My Profit': 'Meu Rendimento',
      'My Team': 'Minha Equipe',
      'Monthly': 'Ativação',
      'Total Bonus': 'Total de Bônus',
      'Current Balance': 'Saldo Atual',
      'Graduation': 'Graduação',
      'No Graduation': 'Sem Graduação',
      'Points': 'Pontos',
      'ACTIVE': 'ATIVO',
      'INACTIVE': 'INATIVO',
    },
    es: {
      'My Investment': 'Mi Inversion',
      'My Profit': 'Mi Rendimiento',
      'My Team': 'Mi Equipo',
      'Monthly': 'Ativação',
      'Total Bonus': 'Total de Bonus',
      'Current Balance': 'Saldo Actual',
      'Graduation': 'Graduación',
      'No Graduation': 'No Graduación',
      'Points': 'Puntos',
      'ACTIVE': 'ATIVO',
      'INACTIVE': 'INATIVO',
    }
  },
  props: {
    type: {
      type: String,
      default: "default"
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    }
  },
  computed: {
    // exibe o ícone apenas quando for uma classe boxicons (ex.: "bx bx-user")
    hasIcon() {
      return this.icon.indexOf("bx") === 0;
    },
    // status que viram badge: ativo/aprovado = sucesso, inativo/pendente = erro
    badge() {
      const map = {
        active: "success",
        approved: "success",
        inactive: "danger",
        pending: "danger"
      };
      return map[this.value] || "";
    },
    badgeLabel() {
      return this.badge === "success" ? this.t("ACTIVE") : this.t("INACTIVE");
    }
  }
};
</script>

<template>
  <div class="card bg-white stat-tile">
    <div class="card-body p-3 pr-4">
      <div v-if="type == 'center'" class="text-center">
        <h5 v-if="badge" class="mb-0 notranslate font-weight-medium"><span :class="'stat-badge-' + badge">{{ badgeLabel }}</span></h5>
        <h5 v-else class="mb-0 notranslate font-weight-medium">{{ t(value) }}</h5>
        <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12" v-html="t(title)"></p>
      </div>
      <div v-else class="d-flex align-items-center">
        <div v-if="hasIcon" class="mr-3">
          <div class="stat-icon">
            <i class="bx font-size-22 text-white align-middle" :class="icon"></i>
          </div>
        </div>
        <div class="flex-fill">
          <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12" v-html="t(title)"></p>
          <h5 v-if="badge" class="mb-0 notranslate font-weight-medium"><span :class="'stat-badge-' + badge">{{ badgeLabel }}</span></h5>
          <h5 v-else class="mb-0 notranslate font-weight-medium">{{ t(value) }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.stat-tile h5,
.stat-tile h6 {
  letter-spacing: -.01em;
}

/* Ícone do card: degradê derivado do vinho da marca Elo */
.stat-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: #fff;
  border-radius: .875rem;
  background: linear-gradient(145deg, #9A2524, #721817);
  box-shadow:
    0 5px 12px rgba(114, 24, 23, 0.25),
    inset 1px 1px 1px rgba(255, 255, 255, 0.45);
}

.stat-icon::after {
  content: "";
  position: absolute;
  top: 1px;
  left: 2px;
  right: 2px;
  height: 45%;
  border-radius: 10px 10px 50% 50%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.22), transparent);
  pointer-events: none;
}

.stat-badge-success,
.stat-badge-danger {
  display: inline-block;
  padding: 0 .5rem;
  border-radius: .25rem;
  color: #fff;
}

.stat-badge-success {
  background: linear-gradient(135deg, #6CD8B3, #27936E);
  box-shadow: 0 4px 10px -3px rgba(39, 147, 110, .5);
}

.stat-badge-danger {
  background: linear-gradient(135deg, #F0545A, #CC1219);
  box-shadow: 0 4px 10px -3px rgba(204, 18, 25, .5);
}
</style>
